/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Container, ContainerProps } from '@material-ui/core';

import useStyles from './styles';

const Box: React.FC<ContainerProps> = ({ children, ...rest }) => {
  const classes = useStyles();

  return (
    <Container className={classes.root} {...rest}>
      {children}
    </Container>
  );
};

export default Box;
